import {useCallback} from 'react'

import {apiGetAllMemexData, cancelGetAllMemexData} from '../../api/memex/api-get-all-memex-data'
import {useApiRequest} from '../../hooks/use-api-request'
import {useViews} from '../../hooks/use-views'
import {useCharts} from '../charts/use-charts'
import {useUpdateColumns} from '../columns/use-update-columns'
import {useCreatedWithTemplateMemex} from '../created-with-template-memex/created-with-template-memex-provider'
import {useSetProject} from '../memex/use-set-project'
import {useWorkflows} from '../workflows/use-workflows'

export const useHandleDataRefresh = () => {
  const {setAllWorkflows} = useWorkflows()
  const {setProject} = useSetProject()
  const {updateColumns} = useUpdateColumns()
  const {updateViewServerStates} = useViews()
  const {updateChartConfigurations} = useCharts()
  const {setCreatedWithTemplateMemex} = useCreatedWithTemplateMemex()

  const {perform: performRefreshRequest, status: refreshRequestStatus} = useApiRequest({
    request: useCallback(() => {
      cancelGetAllMemexData()
      return apiGetAllMemexData()
    }, []),
    showErrorToast: false,
  })

  // eslint-disable-next-line react-hooks/preserve-manual-memoization
  const handleUpdateData = useCallback(async () => {
    await performRefreshRequest()

    if (refreshRequestStatus.current.status === 'succeeded') {
      const {
        memexProject,
        memexProjectAllColumns,
        memexViews,
        memexWorkflows,
        memexWorkflowConfigurations,
        memexCharts,
        createdWithTemplateMemex,
      } = refreshRequestStatus.current.data

      /**
       * Avoid wrapping in a transition, since this will force a url update
       * that could potentially clash with the timing of a transition
       */
      setProject(memexProject)
      updateColumns(memexProjectAllColumns)
      updateViewServerStates(memexViews)
      setAllWorkflows(memexWorkflowConfigurations, memexWorkflows)
      updateChartConfigurations(memexCharts)
      setCreatedWithTemplateMemex(createdWithTemplateMemex)
    }
  }, [
    performRefreshRequest,
    refreshRequestStatus,
    setAllWorkflows,
    setProject,
    updateChartConfigurations,
    updateColumns,
    updateViewServerStates,
    setCreatedWithTemplateMemex,
  ])

  return handleUpdateData
}
